interface IIntersectionData {
  isIntersecting: boolean
  boundingClientRect?: DOMRectReadOnly
}

export function getActiveSection(intersectionData: {
  isOverViewInt: IIntersectionData | null
  isRoomsInt: IIntersectionData | null
  isFacilitiesInt: IIntersectionData | null
  isDetailsInt: IIntersectionData | null
  isReviewsInt: IIntersectionData | null
}) {
  const sectionOrder: Array<keyof typeof intersectionData> = [
    'isOverViewInt',
    'isRoomsInt',
    'isReviewsInt',
    'isDetailsInt',
    'isFacilitiesInt',
  ]

  const defaultState = {
    isOverViewTabSelected: false,
    isRoomsTabSelected: false,
    isFacilitiesTabSelected: false,
    isDetailsTabSelected: false,
    isReviewsTabSelected: false,
  }

  // If no data, select first section
  if (!intersectionData || typeof window === 'undefined') {
    return { ...defaultState, isOverViewTabSelected: true }
  }

  // Check if at bottom of page
  if (
    window.innerHeight + Math.round(window.scrollY) >=
    document.documentElement.offsetHeight - 100
  ) {
    return { ...defaultState, isLocationTabSelected: true }
  }

  // Convert intersection data to sorted array
  const sections = sectionOrder
    .map(id => ({
      sectionId: id,
      isIntersecting: intersectionData[id]?.isIntersecting ?? false,
      top: intersectionData[id]?.boundingClientRect?.top ?? 0,
    }))
    .filter(section => section !== null)

  // Find active section
  const activeSection =
    sections.find(section => section.isIntersecting) ||
    sections.filter(section => section.top <= 0).pop() ||
    sections[0]

  // Map section IDs to their corresponding state keys
  const sectionToStateMap = {
    isOverViewInt: 'isOverViewTabSelected',
    isRoomsInt: 'isRoomsTabSelected',
    isFacilitiesInt: 'isFacilitiesTabSelected',
    isDetailsInt: 'isDetailsTabSelected',
    isReviewsInt: 'isReviewsTabSelected',
  } as const

  return {
    ...defaultState,
    [sectionToStateMap[activeSection.sectionId]]: true,
  }
}
